<template>
  <div class="flex flex-col items-center text-gray-darker">
    <img src="@/assets/img/man_boat.png" alt="" />
    <h1 class="heading-l-700 mb-5">This page doesn’t exist</h1>
    <h3 class="heading-s-400 mb-8">This link may be broken or no longer exist.</h3>
    <BaseButton text="Go Back To Dashboard" @onClick="goToDashboard" />
  </div>
</template>

<script>
import BaseButton from '@/components/shared/buttons/BaseButton';
export default {
  name: 'NotFound',
  components: { BaseButton },
  methods: {
    goToDashboard() {
      this.$router.push('/');
    },
  },
};
</script>
